import DropdownIcon from 'imagesUwKluis/svg/dropdown.svg';
import Box from '../shared/layouts/Box';
import Flex from '../shared/layouts/Flex';
import Link from './Link';

const SubMenu = ({ to, Icon, title, children, onClick, isOpen }) => {
  const isActive = location.pathname.includes(to.split('/').shift());
  return (
    <Box
      bg={isActive ? 'primaryActive' : null}
      color={isActive ? 'primaryContrast' : null}
    >
      <Link to={to} onClick={onClick} isActive={isActive} subMenu>
        <Flex justifyContent="space-between" flexGrow={1} pr="m">
          <Flex minWidth="160px" alignItems="center">
            <Icon width="2rem" height="2rem" />
            <Box pl="m">{title}</Box>
          </Flex>
          <Flex alignItems="center">
            <DropdownIcon
              width="16px"
              height="16px"
              css={isActive && isOpen ? { transform: 'rotate(180deg)' } : ''}
            />
          </Flex>
        </Flex>
      </Link>
      <Box
        pl="xl"
        css={{
          'a > div': { height: '48px', fontSize: '14px', lineHeight: '20px' },
        }}
        color={'primaryContrast'}
      >
        {children}
      </Box>
    </Box>
  );
};

export default SubMenu;
